// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shipment-form {
  margin: 0px auto;
  /* width: 832px; */
}

.guide-link {
  color: #4793ef;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}

.ruleicon {
  width: 24px;
  height: 24px;
  margin-bottom: -6px;
}

img.shipment-image {
  width: 290.72px;
  height: 264.85px;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 41px;
}

.dimensions {
  border: 1px solid #e1e9ef;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin: 25px 5% 0px 5%;
}

.dimensions-form {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 100%;
  height: auto;
}

.dimensions-row {
  display: flex;
  width: 100%;
}

.dimensions-field,
.dimensions-type {
  flex: 1;
  width: 25%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dimensions-field.leftBorder {
  border-left: 1px solid hsla(213, 84%, 61%, 0.15);
}

.dimensions-header {
  background-color: hsla(213, 84%, 61%, 0.15);
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}

.first-circle {
  height: 44px;
  width: 44px;
  background: #ffffff57;
  box-shadow: 0px -1px 7px 0px #bacee580;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  margin-left: 16px;
  align-items: center;
  margin-right: 7px;
}

.second-circle {
  height: 36px;
  width: 36px;
  background-color: #ffffff;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dimensions-type {
  /* width: 226px; */
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dimensions-field {
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dimensions-row > .dimensions-type:first-child,
.dimensions-row > .dimensions-field:first-child,
.dimensions-row > .dimensions-field:last-child {
  padding: 7px 0; /* Añade el padding solo a estos elementos específicos */
}

/* .dimensions-field.long {
    width: 213px;
}


.dimensions-field.high {
    width: 195px;
}


.dimensions-field.broad {
    width: 194px;
} */

h1.title-shipment {
  padding: 0px 5%;
  margin-bottom: 2px;
}

.description-shipment {
  padding: 0px 5%;
  color: #777a7c;
  font-size: 16px;
  font-weight: 400;
  margin-top: 0px;
  word-wrap: break-word;
}

.leftBorder {
  border-left: 1px solid hsla(213, 84%, 61%, 0.15) !important;
  border-bottom: none !important;
  border-top: none !important;
  border-right: none !important;
  border-radius: 0px;
}

.select-container-width {
  width: 178px;
}

.dimensions-header-title {
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  text-align: left;
}

.select-divisor {
  height: 1px;
  margin: 30px 5%;
  background: #e1e9ef;
}

.weight-value {
  display: flex;
  justify-content: space-between;
  margin: 0px 5% 99px 5%;
}

.Weight-container {
  display: flex;
  justify-content: space-between;
  border: 1px solid #e1e9ef;
  border-radius: 8px;
  width: 100%;
}

@media (max-width: 1085px) {
  .dimensions {
    margin: 25px 5% 0px 5% !important;
  }
  
  .dimensions-form {
    flex-wrap: wrap;
    flex-direction: column;
  }

  .dimensions-row {
    width: 100%;
  }
  .dimensions-row:first-of-type > .dimensions-type,
  .dimensions-row:first-of-type > .dimensions-field {
    width: 100%;
  }
  .dimensions-field,
  .dimensions-type {
    width: 50%; /* Adjust the width to 50% for two elements per row */
  }

  .dimensions-row:nth-of-type(2) > .dimensions-field,
  .dimensions-row:nth-of-type(2) > .dimensions-type {
    border-top: 1px solid #e1e9ef !important;
  }

  .dimensions-field.leftBorder {
    border-left: none; /* Remove left border for all elements */
  }

  .dimensions-field:nth-child(odd) {
    border-left: 1px solid hsla(213, 84%, 61%, 0.15); /* Apply left border only to odd elements */
  }
  .dimensions-type {
    justify-content: left;
  }

  .dimensions-row:nth-of-type(2) > .dimensions-field:first-child {
  border-left: 0px !important;
}

  .dimensions-type .select-container-width {
    padding: 0px 5px;
  }

  .select-divisor {
    margin: 30px 5%;
  }

  .weight-value {
    flex-direction: column;
    gap: 16px;
    margin: 0px 5% 99px 5% !important;
  }
  .weight-value {
    flex-direction: column;
    gap: 16px;
    margin: 0px 5% 99px 5% !important;
  }
  .Weight-container {
    margin-right: 0px !important;
  }
}

@media (max-width: 450px) {
  .dimensions {
    margin: 25px 3% 0px 3% !important;
  }
  .leftBorder{
    border-left: 0px !important;
  }
  .weight-value {
    flex-direction: column;
    gap: 16px;
    margin: 0px 3% 99px 3% !important;
  }
  .weight-value {
    flex-direction: column;
    gap: 16px;
    margin: 0px 3% 99px 3% !important;
  }
  .dimensions-row {
    flex-direction: column;
  }
  .dimensions-field,
  .dimensions-type {
    width: 100%; /* Adjust the width to 50% for two elements per row */
  }

  .dimensions-row:nth-of-type(1) > .dimensions-field,
  .dimensions-row:nth-of-type(1) > .dimensions-type {
    border-top: 1px solid #e1e9ef !important;
    /*padding: 6px 10px;*/
  }

  .dimensions-row:nth-of-type(2) > .dimensions-field,
  .dimensions-row:nth-of-type(2) > .dimensions-type {
    border-top: 1px solid #e1e9ef !important;
    padding: 6px 10px;
  }

  .dimensions-type .select-container-width {
    padding: 6px 10px;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ShipmentForm/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,OAAO;EACP,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc,EAAE,wDAAwD;AAC1E;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2DAA2D;EAC3D,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,UAAU,EAAE,qDAAqD;EACnE;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,gDAAgD,EAAE,2CAA2C;EAC/F;EACA;IACE,qBAAqB;EACvB;;EAEA;EACA,2BAA2B;AAC7B;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,iCAAiC;EACnC;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,iCAAiC;EACnC;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,iCAAiC;EACnC;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,WAAW,EAAE,qDAAqD;EACpE;;EAEA;;IAEE,wCAAwC;IACxC,qBAAqB;EACvB;;EAEA;;IAEE,wCAAwC;IACxC,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF","sourcesContent":[".shipment-form {\n  margin: 0px auto;\n  /* width: 832px; */\n}\n\n.guide-link {\n  color: #4793ef;\n  font-size: 16px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.ruleicon {\n  width: 24px;\n  height: 24px;\n  margin-bottom: -6px;\n}\n\nimg.shipment-image {\n  width: 290.72px;\n  height: 264.85px;\n}\n\n.image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 41px;\n}\n\n.dimensions {\n  border: 1px solid #e1e9ef;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  margin: 25px 5% 0px 5%;\n}\n\n.dimensions-form {\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  width: 100%;\n  height: auto;\n}\n\n.dimensions-row {\n  display: flex;\n  width: 100%;\n}\n\n.dimensions-field,\n.dimensions-type {\n  flex: 1;\n  width: 25%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.dimensions-field.leftBorder {\n  border-left: 1px solid hsla(213, 84%, 61%, 0.15);\n}\n\n.dimensions-header {\n  background-color: hsla(213, 84%, 61%, 0.15);\n  height: 60px;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px;\n}\n\n.first-circle {\n  height: 44px;\n  width: 44px;\n  background: #ffffff57;\n  box-shadow: 0px -1px 7px 0px #bacee580;\n  border-radius: 30px;\n  display: flex;\n  justify-content: center;\n  margin-left: 16px;\n  align-items: center;\n  margin-right: 7px;\n}\n\n.second-circle {\n  height: 36px;\n  width: 36px;\n  background-color: #ffffff;\n  border-radius: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.dimensions-type {\n  /* width: 226px; */\n  width: 25%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.dimensions-field {\n  width: 25%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.dimensions-row > .dimensions-type:first-child,\n.dimensions-row > .dimensions-field:first-child,\n.dimensions-row > .dimensions-field:last-child {\n  padding: 7px 0; /* Añade el padding solo a estos elementos específicos */\n}\n\n/* .dimensions-field.long {\n    width: 213px;\n}\n\n\n.dimensions-field.high {\n    width: 195px;\n}\n\n\n.dimensions-field.broad {\n    width: 194px;\n} */\n\nh1.title-shipment {\n  padding: 0px 5%;\n  margin-bottom: 2px;\n}\n\n.description-shipment {\n  padding: 0px 5%;\n  color: #777a7c;\n  font-size: 16px;\n  font-weight: 400;\n  margin-top: 0px;\n  word-wrap: break-word;\n}\n\n.leftBorder {\n  border-left: 1px solid hsla(213, 84%, 61%, 0.15) !important;\n  border-bottom: none !important;\n  border-top: none !important;\n  border-right: none !important;\n  border-radius: 0px;\n}\n\n.select-container-width {\n  width: 178px;\n}\n\n.dimensions-header-title {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 28px;\n  text-align: left;\n}\n\n.select-divisor {\n  height: 1px;\n  margin: 30px 5%;\n  background: #e1e9ef;\n}\n\n.weight-value {\n  display: flex;\n  justify-content: space-between;\n  margin: 0px 5% 99px 5%;\n}\n\n.Weight-container {\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid #e1e9ef;\n  border-radius: 8px;\n  width: 100%;\n}\n\n@media (max-width: 1085px) {\n  .dimensions {\n    margin: 25px 5% 0px 5% !important;\n  }\n  \n  .dimensions-form {\n    flex-wrap: wrap;\n    flex-direction: column;\n  }\n\n  .dimensions-row {\n    width: 100%;\n  }\n  .dimensions-row:first-of-type > .dimensions-type,\n  .dimensions-row:first-of-type > .dimensions-field {\n    width: 100%;\n  }\n  .dimensions-field,\n  .dimensions-type {\n    width: 50%; /* Adjust the width to 50% for two elements per row */\n  }\n\n  .dimensions-row:nth-of-type(2) > .dimensions-field,\n  .dimensions-row:nth-of-type(2) > .dimensions-type {\n    border-top: 1px solid #e1e9ef !important;\n  }\n\n  .dimensions-field.leftBorder {\n    border-left: none; /* Remove left border for all elements */\n  }\n\n  .dimensions-field:nth-child(odd) {\n    border-left: 1px solid hsla(213, 84%, 61%, 0.15); /* Apply left border only to odd elements */\n  }\n  .dimensions-type {\n    justify-content: left;\n  }\n\n  .dimensions-row:nth-of-type(2) > .dimensions-field:first-child {\n  border-left: 0px !important;\n}\n\n  .dimensions-type .select-container-width {\n    padding: 0px 5px;\n  }\n\n  .select-divisor {\n    margin: 30px 5%;\n  }\n\n  .weight-value {\n    flex-direction: column;\n    gap: 16px;\n    margin: 0px 5% 99px 5% !important;\n  }\n  .weight-value {\n    flex-direction: column;\n    gap: 16px;\n    margin: 0px 5% 99px 5% !important;\n  }\n  .Weight-container {\n    margin-right: 0px !important;\n  }\n}\n\n@media (max-width: 450px) {\n  .dimensions {\n    margin: 25px 3% 0px 3% !important;\n  }\n  .leftBorder{\n    border-left: 0px !important;\n  }\n  .weight-value {\n    flex-direction: column;\n    gap: 16px;\n    margin: 0px 3% 99px 3% !important;\n  }\n  .weight-value {\n    flex-direction: column;\n    gap: 16px;\n    margin: 0px 3% 99px 3% !important;\n  }\n  .dimensions-row {\n    flex-direction: column;\n  }\n  .dimensions-field,\n  .dimensions-type {\n    width: 100%; /* Adjust the width to 50% for two elements per row */\n  }\n\n  .dimensions-row:nth-of-type(1) > .dimensions-field,\n  .dimensions-row:nth-of-type(1) > .dimensions-type {\n    border-top: 1px solid #e1e9ef !important;\n    /*padding: 6px 10px;*/\n  }\n\n  .dimensions-row:nth-of-type(2) > .dimensions-field,\n  .dimensions-row:nth-of-type(2) > .dimensions-type {\n    border-top: 1px solid #e1e9ef !important;\n    padding: 6px 10px;\n  }\n\n  .dimensions-type .select-container-width {\n    padding: 6px 10px;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
